export default __webpack_public_path__ + "static/media/Profileselector.0709f83f.svg";